<template>
  <div id="main-content" class="bus-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToAddGrade">+ {{ $t('grade.titleCreate') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row style="padding-top: 20px">
        <table v-if="gradeList" class="bus-list filter-sort-table">
          <tr>
            <th class="input-th" width="5%">#</th>
            <th class="input-th" width="55%">
              <el-input :placeholder="$t('grade.name')" @keyup.native.enter="onGetListGrade" v-model="searchText"></el-input>
              <Sort :model="sort.name" @change="changeSort($event, 'name')"></Sort>
            </th>
            <th>

            </th>
          </tr>
          <tr v-for="(grade, index) in gradeList" :key="grade.id">
            <td>{{ index + 1 }}</td>
            <td>{{ grade.name }}</td>
            <td>
              <b-button variant="outline-primary" class="mr-2" @click="goToDetailGrade(grade.id)">{{ $t('common.detail') }}
              </b-button>
              <b-button variant="danger" @click="deleteGrade(grade.id, index)">{{ $t('common.delete') }}</b-button>
              <b-button variant="warning" class="ml-2" @click="editGrade(grade.id)">{{ $t('common.edit') }}</b-button>
            </td>
          </tr>
        </table>
      </el-row>
      <el-row style="padding-top: 15px">
        <el-pagination
            background
            @current-change="didSelectPage"
            :page-size="dataPage.limit"
            layout="prev, pager, next"
            :current-page="page"
            :total="dataPage.total">
        </el-pagination>
      </el-row>
    </el-col>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
import Sort from '@/components/Sort'
import { ITEM_PER_PAGE } from '@/config'

export default {
  name: 'bus',
  components: {
    PageTitle,
    Sort
  },
  data: function () {
    return {
      backLink: ``,
      title: 'grade.titleList',
      page: 1,
      itemPerPage: ITEM_PER_PAGE,
      gradeList: [],
      searchText:null,
      sort: {
        name: null,
      },
      isBack: false,
      dataPage :  {
        limit: 10
      },
    }
  },
  created() {
    this.onGetListGrade()
  },
  methods: {
    goToAddGrade: function () {
      this.$router.push('/grade-management/create')
    },
    onGetListGrade(){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.gradeList = response.data.data.data_list
            this.dataPage = response.data.data
            this.page = response.data.data.current_page
          }
        },
        errorCallback: () => {},
        sort: this.sort,
        search:this.searchText,
        page: this.page
      }
      this.$store.dispatch('classroom/getListGrade', payload)
    },
    goToDetailGrade(gradeId) {
      this.$router.push({path: `grade-management/${gradeId}`});
    },
    didSelectPage: function (e) {
      this.page = e
      this.onGetListGrade()
    },
    editGrade(gradeId){
      this.$router.push({name: `grade-management-edit`, query:{id:gradeId}});
    },
    deleteGrade(gradeId, index) {
      this.$store.commit('openConfirm', {
        title: this.$t('common.delete'),
        message: this.$t('grade.delete_confirm'),
        callback: () => {
          let successCallback = () =>{
            this.onGetListGrade()
          }
          let payload = {
            successCallback,
            grade_id: gradeId,
            index: index
          }

          this.$store.dispatch('classroom/deleteGrade', payload);
          if(this.gradeList.length=== 1){
            this.page = this.page > 1 ? this.page-1 : 1
          }
        }
      })
    },
    changeSort (type, field) {
      this.sort[field] = type
      this.sort = Object.assign({}, this.sort)
      this.onGetListGrade()
    }
  }
}
</script>
<style lang="scss">
.bus-list {
  width: 100%;
  /*border: 1px solid #DCDFE6;*/
}

table, th, td {
  border: 1px solid #DCDFE6;
  border-collapse: collapse;
}

th {
  height: 55px;
  background-color: rgba(0, 0, 0, 0.2);
  color: #fff;
}

td {
  height: 40px;
}
</style>
